import { render } from "./CResultBanner.vue?vue&type=template&id=0530e6b8&scoped=true"
const script = {}

import "./CResultBanner.vue?vue&type=style&index=0&id=0530e6b8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0530e6b8"]])

export default __exports__